<template>
  <div class="hm-transfer p10">
    <div v-if="queryType !== 'price'">
      <el-input
        v-if="queryType === 'coupon'"
        size="small"
        clearable
        class="mr10"
        style="width: 200px"
        placeholder="请输入券名"
        v-model.trim="searchCondition.name"
      ></el-input>
      <el-input
        v-else
        clearable
        v-model.trim="searchCondition.actName"
        placeholder="输入活动名称"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button size="small" type="primary" @click="search">查询</el-button>
    </div>
    <div class="flex item-center" v-if="queryType === 'coupon'">
      <!-- 左边 -->
      <div>
        <div class=" table-panel" v-if="queryType === 'coupon'">
          <el-radio-group v-model="status" size="small" @change="switchTabs">
            <el-radio-button
              :label="v.index"
              v-for="(v, i) in btnList"
              :key="i"
              >{{ v.name }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="table">
          <div class="table-out-header flex flex-between">
            <div class="flex-1">
              <el-checkbox
                :indeterminate="leftIsIndeterminate"
                :disabled="leftData.length <= 0"
                v-model="leftCheckAll"
                @change="handleLeftCheckAllChange"
                style="float: left"
                >全选</el-checkbox
              >
            </div>
            <div class="transfer-title flex-2 text-center">可选范围</div>
          </div>
          <!-- <div
          class="table-header flex flex-between"
          v-if="queryType === 'promotion'"
        >
          <div class="flex-1 num">活动ID</div>
          <div class="flex-1 name">活动名称</div>
          <div class="flex-1 name text-center">活动状态</div>
          <div class="flex-1 name text-center">活动类型</div>
          <div class="flex-2 name text-center">活动时间</div>
          <div class="flex-1 name text-center">操作</div>
        </div> -->

          <div
            class="table-header flex flex-between"
            v-if="queryType === 'coupon'"
          >
            <div class="flex-1 num">使用对象</div>
            <div class="flex-1 name">优惠券名称</div>
            <div class="flex-1 name text-center">标签</div>
            <div class="flex-1 name text-center">使用门槛</div>
            <div class="flex-2 name text-center">活动时间</div>
            <div class="flex-1 name text-center">操作</div>
          </div>
          <div class="table-header flex flex-between" v-else>
            <div class="flex-1 num">活动ID</div>
            <div class="flex-1 name">活动名称</div>
            <div class="flex-1 name text-center">活动状态</div>
            <!-- <div class="flex-1 name text-center">活动类型</div> -->
            <div class="flex-2 name text-center">活动时间</div>
            <div class="flex-1 name text-center">操作</div>
          </div>
          <div class="table-body">
            <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="height: 500px;"
            >
              <el-checkbox-group
                v-model="leftChecked"
                @change="handleLeftCheckedChange"
              >
                <div
                  v-for="(v, i) in leftData"
                  :key="i"
                  class="check-wrapper flex item-center"
                  :title="v.promotionName"
                >
                  <div class="flex-4" v-if="queryType === 'coupon'">
                    <el-checkbox :label="v" class="flex">
                      <el-tooltip
                        :content="
                          v.isPlus === 0
                            ? 'PLUS会员'
                            : v.isPlus === '1'
                            ? '全部会员'
                            : '全部会员'
                        "
                        placement="top"
                      >
                        <span class="flex-1 attrid">
                          {{
                            v.isPlus === 0
                              ? "PLUS会员"
                              : v.isPlus === "1"
                              ? "全部会员"
                              : "全部会员"
                          }}</span
                        >
                      </el-tooltip>
                      <el-tooltip :content="v.name" placement="top">
                        <span class="flex-1 goods-name">{{ v.name }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.labelName" placement="top">
                        <span class="flex-1 goods-name text-center">{{
                          v.labelName
                        }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.levelMin" placement="top">
                        <span class="flex-1 goods-name text-center">{{
                          v.levelMin
                        }}</span>
                      </el-tooltip>
                      <el-tooltip
                        :content="`${v.ruleStartDate}至${v.ruleEndDate}`"
                        placement="top"
                      >
                        <span class="flex-2 goods-name text-center"
                          >{{ v.ruleStartDate }}至{{ v.ruleEndDate }}</span
                        >
                      </el-tooltip>
                      <span class="flex-1 text-center">
                        <el-button
                          size="small"
                          class="blue"
                          type="text"
                          @click="toDetails(v)"
                          >详情</el-button
                        >
                      </span>
                    </el-checkbox>
                  </div>
                  <div class="flex-4" v-else>
                    <el-checkbox :label="v" class="flex">
                      <el-tooltip :content="v.id" placement="top">
                        <span class="flex-1 attrid">{{ v.id }}</span>
                      </el-tooltip>
                      <el-tooltip :content="v.actName" placement="top">
                        <span class="flex-1 goods-name">{{ v.actName }}</span>
                      </el-tooltip>

                      <span
                        class="success flex-1 goods-name text-center"
                        v-show="v.timeStatus === 'running'"
                        >进行中</span
                      >
                      <span
                        class="gray flex-1 goods-name text-center"
                        v-show="v.timeStatus === 'notStart'"
                        >未开始</span
                      >
                      <span
                        class="danger flex-1 goods-name text-center"
                        v-show="v.timeStatus === 'end'"
                        >已结束</span
                      >

                      <span class="flex-2 goods-name text-center">{{
                        v.date
                      }}</span>
                      <span class="flex-1 text-center">
                        <el-button
                          size="small"
                          class="blue"
                          type="text"
                          @click="toDetails(v)"
                          >详情</el-button
                        >
                      </span>
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total,  prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="flex flex-column control text-center">
        <div class="mb20">操作</div>
        <!-- <el-switch
          v-model="isMustDelivery"
          v-if="showMustDelivery"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="必选"
          inactive-text="可选"
          inactive-value="no"
        >
        </el-switch> -->
        <!-- <el-switch
          size="mini"
          class="transfer-switch"
          v-if="showUseable"
          v-model="whitelistState"
          active-text="黑名单"
          inactive-text="白名单"
          active-value="black"
          inactive-value="white"
        ></el-switch> -->
        <el-button
          size="small"
          class="hmicon icon-youshuangjiantou1"
          @click="allToRight"
          :disabled="leftData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-youjiantou"
          @click="toRight"
          :disabled="leftData.length <= 0 || leftChecked.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuoshuangjiantou1"
          @click="allToLeft"
          :disabled="rightData.length <= 0"
        ></el-button>
        <el-button
          size="small"
          class="hmicon icon-zuojiantou"
          @click="toLeft"
          :disabled="rightData.length <= 0 || rightChecked.length <= 0"
        ></el-button>
        <!-- <el-button
          size="small"
          class="hmicon icon-zuojiantou delete-selected"
          @click="deleteChecked"
          :disabled="leftChecked.length <= 0 || rightData.length <= 0"
        >
          剔除
          <el-tooltip
            class="item"
            effect="dark"
            content="剔除右侧列表和左侧已勾选的相同的选项"
            placement="top-end"
          >
            <i class="hmicon icon-wenhao"></i>
          </el-tooltip>
        </el-button> -->
      </div>
      <!-- 右边 -->
      <div class="table">
        <div class="table-out-header flex flex-between">
          <div class="flex-1">
            <el-checkbox
              :indeterminate="rightIsIndeterminate"
              :disabled="rightData.length <= 0"
              v-model="rightCheckAll"
              @change="handleRightCheckAllChange"
              style="float: left"
              >全选</el-checkbox
            >
          </div>
          <div class="transfer-title flex-2 text-center">已选范围</div>
        </div>
        <div
          class="table-header flex flex-between"
          v-if="queryType === 'promotion'"
        >
          <div class="flex-1 num">活动ID</div>
          <div class="flex-1 name">活动名称</div>
          <div class="flex-1 name text-center">活动状态</div>

          <div class="flex-2 name text-center">活动时间</div>
          <div class="flex-1 name text-center">操作</div>
        </div>
        <div
          class="table-header flex flex-between"
          v-if="queryType === 'coupon'"
        >
          <div class="flex-1 num">使用对象</div>
          <div class="flex-1 name">优惠券名称</div>
          <div class="flex-1 name text-center">标签</div>
          <div class="flex-1 name text-center">使用门槛</div>
          <div class="flex-2 name text-center">活动时间</div>
          <div class="flex-1 name text-center">操作</div>
        </div>
        <div class="table-body">
          <el-scrollbar
            ref="scrollContainer"
            :vertical="false"
            wrap-style="height: 500px;"
          >
            <el-checkbox-group
              v-model="rightChecked"
              @change="handleRightCheckedChange"
            >
              <div
                v-for="(v, i) in rightData"
                :key="i"
                class="check-wrapper item-center"
              >
                <div class="flex-4" v-if="queryType === 'coupon'">
                  <el-checkbox :label="v" class="flex">
                    <el-tooltip
                      :content="
                        v.isPlus === 0
                          ? 'PLUS会员'
                          : v.isPlus === '1'
                          ? '全部会员'
                          : '全部会员'
                      "
                      placement="top"
                    >
                      <span class="flex-1 attrid">{{
                        v.isPlus === 0
                          ? "PLUS会员"
                          : v.isPlus === "1"
                          ? "全部会员"
                          : "全部会员"
                      }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.name" placement="top">
                      <span class="flex-1 goods-name">{{ v.name }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.labelName" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.labelName
                      }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.levelMin" placement="top">
                      <span class="flex-1 goods-name text-center">{{
                        v.levelMin
                      }}</span>
                    </el-tooltip>
                    <el-tooltip
                      :content="`${v.ruleStartDate}至${v.ruleEndDate}`"
                      placement="top"
                    >
                      <span class="flex-2 goods-name text-center"
                        >{{ v.ruleStartDate }}至{{ v.ruleEndDate }}</span
                      >
                    </el-tooltip>
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span>
                  </el-checkbox>
                </div>
                <div class="flex-4" v-else>
                  <el-checkbox :label="v" class="flex">
                    <el-tooltip :content="v.id" placement="top">
                      <span class="flex-1 attrid">{{ v.id }}</span>
                    </el-tooltip>
                    <el-tooltip :content="v.actName" placement="top">
                      <span class="flex-1 goods-name">{{ v.actName }}</span>
                    </el-tooltip>

                    <span
                      class="success flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'running'"
                      >进行中</span
                    >
                    <span
                      class="gray flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'notStart'"
                      >未开始</span
                    >
                    <span
                      class="danger flex-1 goods-name text-center"
                      v-show="v.timeStatus === 'end'"
                      >已结束</span
                    >

                    <span class="flex-2 goods-name text-center">{{
                      v.date
                    }}</span>
                    <span class="flex-1 text-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >详情</el-button
                      >
                    </span>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-scrollbar>
          <div class="hm-pagination">
            <el-pagination background style="opacity: 0"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-table
        stripe
        ref="table"
        :data="leftData"
        @row-click="checkId"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column label width="65">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="masterId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="actName"
          align="center"
          label="活动名称"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="活动状态">
          <template slot-scope="scope">
            <div class="item-center">
              <span class="success" v-if="scope.row.timeStatus === 'running'"
                >进行中</span
              >
              <span class="gray" v-else-if="scope.row.timeStatus === 'notStart'"
                >未开始</span
              >
              <span class="danger" v-else-if="scope.row.timeStatus === 'end'"
                >已结束</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="240px"
          prop="date"
          label="活动日期"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="地点"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="toDetails(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div v-show="queryType === 'price'">
      <div class="flex flex-end">
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div>
        <el-table
          stripe
          border
          ref="table"
          :data="rightData"
          style="width: 100%"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="selectId"
            label="商品货号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="handPrice"
            label="到手价"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="activityStartTime"
            label="到手价开始时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="activityEndTime"
            label="到手价结束时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="timeRemark"
            label="时段备注"
          >
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="删除" placement="top">
                  <div class="pointer mr10" @click="removeGoods(scope.$index)">
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  props: {
    // showUseable: {
    //   type: Boolean,
    //   default: false
    // },
    showAttribute: {
      type: Boolean,
      default: false
    },
    onlySelectGoods: {
      type: Boolean,
      default: false
    },
    showMustDelivery: {
      type: Boolean,
      default: false
    },
    beltTypes: {
      type: String,
      default: "promotion"
    },
    leftName: { type: String },
    rightName: { type: String },
    leftOption: { type: Array },
    queryIsUsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      status: 1,
      btnList: [
        { name: "进行中", active: false, index: 1 },
        { name: "未开始", active: false, index: 0 }
        // { name: "已过期", active: false, index: 5 },
        // { name: "已作废", active: false, index: 2 },
        // { name: "全部", active: true, index: 4 }
      ],
      masterId: "",
      queryType: this.beltTypes,
      searchCondition: {},
      pageSize: 10,
      currentPage: 1,
      total: 0,
      whitelistState: "white",
      isCheckedAttribute: false,
      isMustDelivery: false,
      catId: "",
      brandId: "",
      goodsName: "",
      categoryList: [],
      brandList: [],
      leftCheckAll: false,
      leftChecked: [],
      leftData: [],
      leftIsIndeterminate: false,
      rightCheckAll: false,
      rightChecked: [],
      rightData: [],
      rightIsIndeterminate: false,
      isEnableSession: false,
      sendWayType: "",
      isChecked: false,
      props: {
        value: "id",
        label: "name",
        children: "children",
        isLeaf: "leaf"
      },
      attributeProps: {
        value: "attrId",
        label: "attrValue",
        children: "children",
        isLeaf: "leaf"
      }
    };
  },
  computed: mapGetters([
    "offlineGoodsListResult",
    "offlineBrandList",
    "crossQueryResult"
  ]),
  watch: {
    // showUseable(val) {
    //   if (val) {
    //     this.whitelistState = "white";
    //   }
    // },
    beltTypes(val) {
      this.queryType = val;
      this.queryActivityList();
    },
    crossQueryResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    offlineGoodsListResult(val) {
      if (val.length) {
        this.leftData = val;
        this.leftData.forEach(v => {
          v.goodsPackageNum = 1;
          if (v.goodsName) {
            v.goodsInfo = v.goodsName;
          }
        });
      } else {
        this.leftData = [];
      }
    },
    // queryType(val) {
    //   this.queryType = val;
    //   this.queryActivityList();
    // },
    leftOption(val) {
      this.leftData = val;
    },
    rightChecked(val) {
      if (this.rightName === "给下列导购发放优惠券") {
        this.$store.commit("queryIsEnable", val.length > 0);
      }
      this.$emit("checkGoods", val.length > 0);
    }
  },
  mounted() {
    this.queryActivityList();
    // this.$store.dispatch("queryOfflineBrandList");
  },
  methods: {
    checkId(row) {
      this.masterId = row.id;
    },
    toDetails(row) {
      if (this.queryType === "promotion") {
        // this.$router.push({
        //   name: "ActivityDetails",
        //   query: {
        //     id: row.id,
        //     type: row.auditState,
        //     parentId: row.promotionCode.split("-")[0],
        //     mode: "view"
        //   }
        // });
        let routeData = this.$router.resolve({
          name: "EventDetails",
          query: {
            id: row.id
          }
        });
        window.open(routeData.href, "_blank");
      } else if (this.queryType === "coupon") {
        // this.$router.push({
        //   name: "Set",
        //   query: {
        //     type: "detail",
        //     ruleId: row.ruleId,
        //     couponStatus: row.couponStatus,
        //     couponType: row.useRank
        //   }
        // });
        let routeData = this.$router.resolve({
          name: "Set",
          query: {
            type: "detail",
            ruleId: row.ruleId,
            couponStatus: row.couponStatus,
            couponType: row.useRank
          }
        });
        window.open(routeData.href, "_blank");
      }
    },
    removeGoods(index) {
      this.rightData.splice(index, 1);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商品名称",
          "商品货号",
          "到手价",
          "到手价开始时间(请使用文本格式)",
          "到手价结束时间(请使用文本格式)",
          "时段备注"
        ];
        const data = [
          ["测试商品", "ABC123", "100", "2020-01-30", "2020-01-31", "限时特惠"]
        ];

        exportJsonToExcel(tHeader, data, "商品模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isValid = true;
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] || !v[2] || !v[3] || !v[4] || !v[5]) {
            isRequired = false;
          } else {
            if (!that.isString(v[3]) || !that.isString(v[4])) {
              isValid = false;
            }
          }
          formatResult.push({
            wxshopSpuName: v[0],
            selectId: v[1] + "",
            handPrice: v[2],
            activityStartTime: `${v[3]} 00:00:00`,
            activityEndTime: `${v[4]} 23:59:59`,
            timeRemark: v[5]
          });
        });
        if (isValid && isRequired) {
          that.rightData = formatResult;
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商品信息！",
              type: "warning"
            });
          } else if (!isValid) {
            that.$message({
              message: "导入失败，日期请使用文本格式导入！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    isString(value) {
      return typeof value === "string";
    },
    switchTabs(index) {
      this.currentPage = 1;
      this.queryActivityList();
    },
    switchTab() {
      this.rightData = [];
      this.currentPage = 1;
      this.rightCheckAll = false;
      if (this.queryType !== "price") {
        this.queryActivityList();
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryActivityList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryActivityList();
    },
    async queryActivityList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        timeStatus: "QRCode",
        status: this.status === 4 ? "" : this.status
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startDate =
        this.searchCondition.ruleValidDate &&
        this.searchCondition.ruleValidDate.length > 0
          ? this.searchCondition.ruleValidDate[0]
          : "";
      searchCondition.endDate =
        this.searchCondition.ruleValidDate &&
        this.searchCondition.ruleValidDate.length > 0
          ? this.searchCondition.ruleValidDate[1]
          : "";

      let name =
        this.queryType === "promotion" ? "subActivityList" : "getAllRules";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } =
        this.queryType === "promotion" ? result.activityList : result;
      if (this.queryType === "promotion") {
        records.forEach(v => {
          v.date =
            v.actStartTime.split(" ")[0] + "至" + v.actStartTime.split(" ")[1];
        });
      } else {
        records.forEach(v => {
          v.id = v.ruleId;
        });
      }
      this.leftData = records;
      this.rightData.forEach(v => {
        this.leftData.forEach((item, index) => {
          if (v.id === item.id) {
            this.leftData.splice(index, 1);
          }
        });
      });
      //   if (this.queryType === "promotion") {
      //   } else if (this.queryType === "coupon") {
      //     this.rightData.forEach(v => {
      //       this.leftData.forEach((item, index) => {
      //         if (v.ruleId === item.ruleId) {
      //           this.leftData.splice(index, 1);
      //         }
      //       });
      //     });
      //   }

      this.total = total;
    },
    filterInteger(value, i) {
      if (value.length == 1) {
        this.rightData[i].goodsPackageNum = value.replace(/[^1-9]/g, "");
      } else {
        this.rightData[i].goodsPackageNum = value.replace(/\D/g, "");
      }
      this.$forceUpdate();
    },
    search() {
      this.currentPage = 1;
      this.queryActivityList();
    },
    // queryGoodsList() {
    //   const checkCateGoryList = this.$refs.tree.getCheckedNodes();
    //   if (this.onlySelectGoods && !this.isCheckedAttribute) {
    //     // 交叉查询
    //     const offlineId = [];
    //     if (checkCateGoryList.length) {
    //       checkCateGoryList.forEach(v => {
    //         offlineId.push(v.attrId);
    //       });
    //     }
    //     this.$store.dispatch("queryOfflineGoodsListResult", {
    //       goodsName: this.goodsName,
    //       brandId: this.brandId,
    //       offlineId
    //     });
    //   } else {
    //     if (this.isChecked && !this.brandId && !this.goodsName) {
    //       // 只查品类
    //       this.leftData = checkCateGoryList || [];
    //     } else if (!this.isChecked && this.brandId && !this.goodsName) {
    //       // 只查品牌
    //       this.leftData =
    //         this.offlineBrandList.filter(v => v.attrId === this.brandId) || [];
    //     } else if (!this.isChecked && !this.brandId && this.goodsName) {
    //       // 只查商品
    //       this.$store.dispatch("queryOfflineGoodsListResult", {
    //         goodsName: this.goodsName
    //       });
    //     } else if (this.isCheckedAttribute) {
    //       // 只查标签
    //       const attributeList = this.$refs.attributeTree.getCheckedNodes();
    //       this.leftData =
    //         attributeList.filter(o => o.attrType === "attribute") || [];
    //     } else {
    //       // 交叉查询
    //       const offlineId = [];
    //       if (checkCateGoryList.length) {
    //         checkCateGoryList.forEach(v => {
    //           offlineId.push(v.attrId);
    //         });
    //       }
    //       this.$store.dispatch("crossQueryGoods", {
    //         goodsName: this.goodsName,
    //         brandId: this.brandId,
    //         offlineId
    //       });
    //     }
    //   }
    // },
    resetGoodsList() {
      this.$refs.tree.setCheckedNodes([]);
      this.brandId = "";
      this.goodsName = "";
    },
    handleLeftCheckAllChange(val) {
      // 选择左边的全选
      this.leftChecked = val ? this.leftData : [];
      this.leftIsIndeterminate = false;
    },
    handleLeftCheckedChange(value) {
      // 选择左边的checkbox
      let checkedCount = value.length;
      this.leftCheckAll = checkedCount === this.leftData.length;
      this.leftIsIndeterminate =
        checkedCount > 0 && checkedCount < this.leftData.length;
    },
    handleRightCheckAllChange(val) {
      // 选择右边的全选
      this.rightChecked = val ? this.rightData : [];
      this.rightIsIndeterminate = false;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    handleRightCheckedChange(value) {
      // 选择右边的checkbox
      let checkedCount = value.length;
      this.rightCheckAll = checkedCount === this.rightData.length;
      this.rightIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rightData.length;
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    allToRight() {
      // 移动所有到右边
      const result = this.checkCommon(this.leftData, this.rightData);
      if (!result) {
        if (this.showUseable) {
          this.leftData.forEach(v => {
            v.whitelistState = this.whitelistState;
          });
        }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
          //   this.$store
          //     .dispatch("queryGoodsIsUsed", {
          //       leftData: this.leftData
          //     })
          //     .then(res => {
          //       if (this.leftData.length > 0) {
          //         this.rightData = this.rightData.concat(res.result);
          //         this.rightData.forEach(v => {
          //           v.activityName = v.existActivity
          //             ? v.existActivity.map(item => item.promotionName)
          //             : [];
          //           v.activityStr = v.activityName.join(",");
          //           if (this.isMustDelivery) {
          //             v.isMustDelivery = this.isMustDelivery;
          //           }
          //         });
          //         this.leftData = [];
          //         this.leftChecked = [];
          //       }
          //       this.handleRightCheckAllChange(true);
          //       this.leftCheckAll = false;
          //       this.rightCheckAll = true;
          //     });
        } else {
          if (this.leftData.length > 0) {
            this.rightData = this.rightData.concat(this.leftData);
            this.rightData.forEach(v => {
              if (this.isMustDelivery) {
                v.isMustDelivery = this.isMustDelivery;
              }
            });
            this.leftData = [];
            this.leftChecked = [];
          }
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        }
      }
    },
    toRight() {
      // 移动选中到右边
      const result = this.checkCommon(this.leftChecked, this.rightData);
      if (!result) {
        // if (this.showUseable) {
        //   this.leftData.forEach(v => {
        //     v.whitelistState = this.whitelistState;
        //   });
        // }
        if (this.queryIsUsed) {
          this.rightData = this.leftData;
          this.rightData.forEach(v => {
            v.activityName = v.existActivity
              ? v.existActivity.map(item => item.promotionName)
              : [];
            v.activityStr = v.activityName.join(",");
            if (this.isMustDelivery) {
              v.isMustDelivery = this.isMustDelivery;
            }
          });

          this.leftData = [];
          this.leftChecked = [];
          this.handleRightCheckAllChange(true);
          this.leftCheckAll = false;
          this.rightCheckAll = true;
        } else {
          this.rightData = this.rightData.concat(this.leftChecked);
          //   this.rightData.forEach(v => {
          //     if (this.isMustDelivery) {
          //       v.isMustDelivery = this.isMustDelivery;
          //     }
          //   });
        }
        if (this.leftChecked.length === this.leftData.length) {
          this.leftData = [];
        } else if (this.leftChecked.length === 1) {
          this.leftData.forEach((v, i) => {
            if (v.id === this.leftChecked[0].id) {
              this.leftData.splice(i, 1);
            }
          });
        } else {
          this.leftChecked.forEach(v => {
            this.leftData.forEach((item, index) => {
              if (v.id === item.id) {
                this.leftData.splice(index, 1);
              }
            });
          });
        }
        this.leftChecked = [];
        this.leftIsIndeterminate = false;
        this.leftCheckAll = false;
        this.handleRightCheckAllChange(true);
        this.rightCheckAll = true;
      }
    },
    allToLeft() {
      // 移动所有到左边
      const result = this.checkCommon(this.rightData, this.leftData);
      if (!result) {
        this.rightCheckAll = false;
        this.rightIsIndeterminate = false;
        if (this.rightData.length > 0) {
          this.leftData = this.leftData.concat(this.rightData);
          this.rightData = [];
          this.rightChecked = [];
        }
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    toLeft() {
      // 移动选中到左边
      const result = this.checkCommon(this.rightChecked, this.leftData);

      if (!result) {
        this.leftData = this.leftData.concat(this.rightChecked);
        if (this.rightChecked.length === this.rightData.length) {
          this.rightData = [];
          this.rightChecked = [];
          this.rightCheckAll = false;
        } else if (this.rightChecked.length === 1) {
          this.rightData.forEach((v, i) => {
            if (v.id === this.rightChecked[0].id) {
              this.rightData.splice(i, 1);
            }
          });
          this.rightChecked = [];
        } else {
          this.rightChecked.forEach(v => {
            this.rightData.forEach((item, index) => {
              if (v.id === item.id) {
                this.rightData.splice(index, 1);
              }
            });
          });
        }
        this.rightChecked = [];
        this.rightIsIndeterminate = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    deleteChecked() {
      // 剔除右边和左边相同的
      if (this.leftChecked.length > 0) {
        this.leftChecked.forEach(v => {
          this.rightData.forEach((item, index) => {
            if (v.name === item.name) {
              this.rightData.splice(index, 1);
            }
          });
        });
        this.rightCheckAll = false;
      }
      this.$emit("getGuiderCount", this.rightChecked.length);
    },
    checkCommon(checkedData, data) {
      let result = false;
      checkedData.forEach(v => {
        data.forEach(item => {
          if (String(v.id) === String(item.id)) {
            this.$message({
              message: "请不要移动重复项",
              type: "warning"
            });
            result = true;
          }
        });
      });
      return result;
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    handleCheckChangeAttribute() {
      this.isCheckedAttribute =
        this.$refs.attributeTree.getCheckedNodes().length > 0;
    },
    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    loadAttributeNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestAttributeTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getAttributeIndex(node, resolve);
      }
    },
    // 首次加载属性数
    requestAttributeTree(resolve) {
      this.$store
        .dispatch("queryAttrListByAddGoods")
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.valueId;
            v.attrValue = v.attributeValue;
            v.attrType = "attribute";
            v.disabled = true;
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 首次加载一级节点数据函数
    requestTree(resolve) {
      this.$store
        .dispatch("queryOfflineCategoryList", {
          level: 0,
          offlineId: ""
        })
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.id;
            v.attrValue = v.name;
            v.attrType = "category";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      this.$store
        .dispatch("queryOfflineCategoryList", {
          offlineId: node.data.id,
          level: node.level
        })
        .then(res => {
          const data = res.result;

          data.forEach(v => {
            v.attrId = v.id;
            v.attrValue = v.name;
            v.attrType = "category";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    getAttributeIndex(node, resolve) {
      //   if (node.level > 1) return resolve([]);
      let params = {};
      if (node.level === 1) {
        params = {
          typeId: node.data.valueId
        };
      } else {
        params = {
          attributeId: node.data.valueId
        };
      }
      this.$store
        .dispatch("queryAttrListByAddGoods", params)
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.valueId;
            v.attrValue = v.attributeValue;
            v.attrType = "attribute";
          });
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }
};
</script>
<style lang="scss">
.hm-transfer {
  border: 1px solid rgba(221, 221, 221, 1);
  border-radius: 6px;
  .table-body {
    .check-wrapper {
      padding-left: 12px;
    }
    .el-checkbox {
      width: 100%;
    }

    .el-checkbox__label {
      width: calc(100% - 24px);
      display: flex;
    }
    .check-wrapper:nth-child(even) {
      background: #f7f7f7;
    }
  }
  .el-checkbox {
    margin-right: 0;
  }
}
</style>

<style lang="scss" scoped>
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.tree-wrapper {
  width: 500px;
}
.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 500px;
  border-radius: 5px;
}
.transfer-header {
  padding: 1rem;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.table-out-header {
  position: relative;
}
.transfer-body {
  padding: 1rem;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}
.control {
  width: 130px;
  margin: 0 2rem;
  .el-button {
    margin: 0.5rem;
  }
}
.coupon-type,
.coupon-count,
.check-wrapper {
  padding: 12px;
  font-size: 14px;
}
.delete-selected {
  position: relative;
  .hmicon icon-wenhao {
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 1.2rem;
    color: #4680ff;
  }
}
.checkbox-group-wrapper {
  border-left: 1px solid #e7e8ec;
  border-right: 1px solid #e7e8ec;
  padding: 0 0.5rem;
}

input[type="number"] {
  width: 2rem;
  border: none;
  outline: none;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.leftName,
.rightName {
  margin-left: -52px;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.minus,
.plus {
  transition: background 0.2s linear;
  cursor: pointer;
}
.disabled {
  color: rgb(220, 223, 230);
  cursor: not-allowed;
}

.divide {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }
  .el-checkbox__label {
    span {
      flex: 1;
      -webkit-flex: 1;
      padding-right: 0.5rem;
    }
  }

  .check-wrapper {
    margin: 1rem 0;
  }
}

.transfer-body {
  .divide-header {
    display: flex;
    display: -webkit-flex;
    padding-left: 24px;
    border-bottom: 1px solid #e7e8ec;
    padding-bottom: 1rem;
    color: #999;
    width: 100%;
    box-sizing: border-box;
    height: 30px;
    .count {
      width: 56px;
    }
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-name.flex1 {
      flex: 1;
      -webkit-flex: 1;
    }
    .devide-type {
      span {
        padding-right: 0.5rem;
      }
    }
  }
  .check-wrapper {
    margin: 1rem 0;
  }
  .devide-body {
    .devide-type,
    .coupon-type,
    .coupon-target {
      display: flex;
      flex: 1;
      -webkit-flex: 1;
    }
    .coupon-name {
      display: flex;
      flex: 2;
      -webkit-flex: 2;
    }
    .coupon-type {
      display: flex;
      align-items: center;
    }
  }
}
.table {
  margin: 20px 0;
  border: 1px solid #eaeaea;
  //   max-width: 500px;
  width: 700px;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      margin-left: 26px;
    }
    .name {
      margin-left: -26px;
    }
  }
  .table-body {
    font-size: 12px;

    .ipt {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      outline: none;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
  .goods-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    box-sizing: border-box;
    width: 100px;
  }
}

.attrid {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 195px;
}
</style>
